import { css } from 'styled-components';
import { cssVar } from 'src/app/styles/helper';
import { mediaQuery } from 'src/app/styles/helper';

export type TypographySize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

export const heading3xl = css`
  font-size: ${cssVar('font-size-display-3xl')};
  line-height: ${cssVar('line-height-display-3xl')};
  font-weight: ${cssVar('font-weight-semibold')};

  ${mediaQuery(
    'md',
    css`
      font-size: ${cssVar('font-size-display-2xl')};
      line-height: ${cssVar('line-height-display-2xl')};
    `
  )}

  ${mediaQuery(
    'sm',
    css`
      font-size: ${cssVar('font-size-display-xl')};
      line-height: ${cssVar('line-height-display-xl')};
    `
  )}
`;

export const heading2xl = css`
  font-size: ${cssVar('font-size-display-2xl')};
  line-height: ${cssVar('line-height-display-2xl')};
  font-weight: ${cssVar('font-weight-semibold')};

  ${mediaQuery(
    'md',
    css`
      font-size: ${cssVar('font-size-display-xl')};
      line-height: ${cssVar('line-height-display-xl')};
    `
  )}

  ${mediaQuery(
    'sm',
    css`
      font-size: ${cssVar('font-size-display-lg')};
      line-height: ${cssVar('line-height-display-lg')};
    `
  )}
`;

export const headingXl = css`
  font-size: ${cssVar('font-size-display-xl')};
  line-height: ${cssVar('line-height-display-xl')};
  font-weight: ${cssVar('font-weight-semibold')};

  ${mediaQuery(
    'md',
    css`
      font-size: ${cssVar('font-size-display-lg')};
      line-height: ${cssVar('line-height-display-lg')};
    `
  )}

  ${mediaQuery(
    'sm',
    css`
      font-size: ${cssVar('font-size-display-md')};
      line-height: ${cssVar('line-height-display-md')};
    `
  )}
`;

export const headingLg = css`
  font-size: ${cssVar('font-size-display-lg')};
  line-height: ${cssVar('line-height-display-lg')};
  font-weight: ${cssVar('font-weight-semibold')};

  ${mediaQuery(
    'md',
    css`
      font-size: ${cssVar('font-size-display-md')};
      line-height: ${cssVar('line-height-display-md')};
    `
  )}

  ${mediaQuery(
    'sm',
    css`
      font-size: ${cssVar('font-size-display-sm')};
      line-height: ${cssVar('line-height-display-sm')};
    `
  )}
`;

export const headingMd = css`
  font-size: ${cssVar('font-size-display-md')};
  line-height: ${cssVar('line-height-display-md')};
  font-weight: ${cssVar('font-weight-semibold')};

  ${mediaQuery(
    'md',
    css`
      font-size: ${cssVar('font-size-display-sm')};
      line-height: ${cssVar('line-height-display-sm')};
    `
  )}

  ${mediaQuery(
    'sm',
    css`
      font-size: ${cssVar('font-size-display-xs')};
      line-height: ${cssVar('line-height-display-xs')};
    `
  )}
`;

export const headingSm = css`
  font-size: ${cssVar('font-size-display-sm')};
  line-height: ${cssVar('line-height-display-sm')};
  font-weight: ${cssVar('font-weight-medium')};

  ${mediaQuery(
    'md',
    css`
      font-size: ${cssVar('font-size-display-xs')};
      line-height: ${cssVar('line-height-display-xs')};
    `
  )}

  ${mediaQuery(
    'sm',
    css`
      font-size: ${cssVar('font-size-text-xl')};
      line-height: ${cssVar('line-height-text-xl')};
    `
  )}
`;

export const headingXs = css`
  font-size: ${cssVar('font-size-display-xs')};
  line-height: ${cssVar('line-height-display-xs')};
  font-weight: ${cssVar('font-weight-medium')};

  ${mediaQuery(
    'md',
    css`
      font-size: ${cssVar('font-size-text-xl')};
      line-height: ${cssVar('line-height-text-xl')};
    `
  )}
`;

export const HEADING_STYLES: Record<TypographySize, ReturnType<typeof css>> = {
  '3xl': heading3xl,
  '2xl': heading2xl,
  xl: headingXl,
  lg: headingLg,
  md: headingMd,
  sm: headingSm,
  xs: headingXs,
};
